import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import AddressIcon from './AddressIcon';
import { KIND_LABEL, highlight, primaryText, secondaryText } from './addressFormat';
import T from './tokens';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    padding: '13px 12px 13px 10px',
    textAlign: 'left',
    borderBottom: `1px solid ${T.lineSoft}`,
    borderRadius: 0,
    transition: 'background-color .12s',
    '&:hover, &$active': { backgroundColor: T.primarySoft },
  },
  active: {},
  icon: {
    flex: 'none',
    width: 22,
    marginTop: 2,
    marginRight: 10,
    color: T.muted,
    display: 'flex',
  },
  iconPlace: { color: T.primary },
  body: { flex: 1, minWidth: 0 },
  primary: {
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: -0.8,
    color: T.ink,
    wordBreak: 'keep-all',
  },
  hit: { color: T.primaryDark, fontWeight: 700 },
  meta: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 6,
    marginTop: 4,
  },
  tag: {
    display: 'inline-block',
    padding: '0 6px',
    height: 20,
    lineHeight: '20px',
    fontSize: 12,
    letterSpacing: -0.5,
    borderRadius: 4,
    color: T.primaryDark,
    backgroundColor: T.primarySoft,
  },
  tagZip: {
    color: T.text,
    backgroundColor: T.lineSoft,
    fontVariantNumeric: 'tabular-nums',
  },
  secondary: {
    fontSize: 14,
    lineHeight: 1.5,
    letterSpacing: -0.7,
    color: T.muted,
    wordBreak: 'keep-all',
  },
}));

function Highlighted({ text, query, hitClass }) {
  return (
    <>
      {highlight(text, query).map((seg, i) => (
        seg.hit ? <mark key={i} className={hitClass} style={{ background: 'none' }}>{seg.text}</mark> : <React.Fragment key={i}>{seg.text}</React.Fragment>
      ))}
    </>
  );
}

// 결과 한 줄 — 첫 줄 주소(검색어 강조), 태그(도로명·지번·건물, 우편번호), 둘째 줄 보조 주소
function AddressResultItem({ item, query, active, onSelect, id }) {
  const cs = useStyles();
  const secondary = secondaryText(item);
  const isPlace = item.kind === 'place';

  return (
    <ButtonBase
      id={id}
      role="option"
      aria-selected={active}
      className={clsx(cs.root, active && cs.active)}
      onClick={() => onSelect(item)}
      focusRipple={false}
    >
      <span className={clsx(cs.icon, isPlace && cs.iconPlace)}>
        <AddressIcon name={isPlace ? 'building' : 'pin'} />
      </span>
      <span className={cs.body}>
        <div className={cs.primary}>
          <Highlighted text={primaryText(item)} query={query} hitClass={cs.hit} />
        </div>
        <div className={cs.meta}>
          <span className={cs.tag}>{KIND_LABEL[item.kind] || '주소'}</span>
          {item.zonecode && <span className={clsx(cs.tag, cs.tagZip)}>{item.zonecode}</span>}
        </div>
        {secondary && (
          <div className={cs.secondary}>
            <Highlighted text={secondary} query={query} hitClass={cs.hit} />
          </div>
        )}
      </span>
    </ButtonBase>
  );
}

export default AddressResultItem;
